import angular from 'angular';
import existingAssetList from './existingAssetList';

export default angular
  .module('components.existingAssetList', [])
  .component('existingAssetList', existingAssetList).name;
